import React from 'react';
import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import { Label, Select } from '@rebass/forms';
import useQuery from 'hooks/useQuery';
import service_accounts from 'services/accounts';
import services from 'services/services';
import helpers from 'utils/helpers';
import { useToastHelper } from 'hooks/useToastHelper';

/**
 * Sender Profile select component for forms.
 * Only displays if there are sender profiles and at least one verified domain.
 *
 * @param {Object} props - Component props
 * @param {Object} props.auth - Auth object containing account information
 * @param {string} props.name - Name attribute for the select input
 * @param {string|number} props.value - Currently selected sender profile ID
 * @param {function} props.onChange - Change handler function
 * @param {string} [props.id] - Optional ID for the select element
 */
export function SenderProfileFormSelect({ auth, name, value, onChange, id }) {
    const { addErrorToast } = useToastHelper();

    const { data: senderProfiles, isLoading } = useQuery({
        queryFn: () => service_accounts.getSenderProfiles(),
        onError: error => {
            const errorText = services.parseAndTrackXhrErrors(error);
            addErrorToast(errorText);
        }
    });

    // Don't render if no verified domain, still loading, or no sender profiles
    if (!helpers.hasVerifiedDomain(auth.account) || isLoading || !senderProfiles?.length) {
        return null;
    }

    return (
        <>
            <div className="form-label form-row-margin">
                From Email (Sender Profile){' '}
                <Link target="_blank" to="/settings#email-domains" style={{ height: '16px' }}>
                    <FiExternalLink style={{ margin: '3px 0px' }} title="Go to email domains settings" role="img" />
                </Link>
            </div>
            <div>
                <Select id={id} name={name} value={value || ''} onChange={onChange}>
                    <option value="">Use account default</option>
                    {senderProfiles.map(profile => (
                        <option key={profile.id} value={profile.id}>
                            {profile.name} &lt;{profile.email}&gt;
                        </option>
                    ))}
                </Select>
            </div>
        </>
    );
}
